'use client';

import { ReactNode, useEffect } from 'react';
import { Button } from '../../Commons/Button';
import LoadingSpinner from '../../Commons/LoadingSpinner/LoadingSpinner';
import ShowTokensStore from '../ShowTokensStore';
import TaskProcessing from '../TaskProcessing/TaskProcessing';
import { useAppGeneral } from './useAppGeneral';
import { convertMillisToTime } from '@/src/lib/MayzSmartDB';
import styles from './AppGeneral.module.scss';

interface AppGeneralProps {
    children: ReactNode;
    loader?: ReactNode;
    onLoadComplete?: () => void;
}
export function AppGeneral({
    children,
    loader = (
        <div>
            Loading application, please wait... <LoadingSpinner />
        </div>
    ),
    onLoadComplete,
}: AppGeneralProps) {
    //--------------------------------------
    const {
        appStore,
        tokensStore,
        initial1,
        setinitial1,
        initial2,
        setinitial2,
        showHistoricTask,
        setShowHistoricTask,
        isProcessingTask,
        setIsProcessingTask,
        isFaildedTask,
        setIsFaildedTask,
        isConfirmedTask,
        setIsConfirmedTask,
        processingTaskMessage,
        setProcessingTaskMessage,
        updateHistoryTask,
        JobManagerFrontEnd,
    } = useAppGeneral({ onLoadComplete });
    //--------------------------------------

    return (
        <>
            {appStore.swInitApiCompleted === true ? (
                <>
                    {children}
                    <>
                        <ShowTokensStore />
                        {appStore.siteSettings?.debug === true && showHistoricTask ? (
                            <>
                                {' '}
                                <TaskProcessing
                                    isProcessingTask={isProcessingTask}
                                    processingTaskMessage={processingTaskMessage}
                                    isFaildedTask={isFaildedTask}
                                    setIsFaildedTask={setIsFaildedTask}
                                    isConfirmedTask={isConfirmedTask}
                                    setIsConfirmedTask={setIsConfirmedTask}
                                    onRetryTask={updateHistoryTask.bind(null, false)}
                                    othersButtonsWhenFailed={
                                        <>
                                            <Button
                                                mode="action"
                                                size="large"
                                                width={200}
                                                onClick={() => {
                                                    updateHistoryTask(true);
                                                }}
                                            >
                                                Force Re-Start
                                            </Button>
                                        </>
                                    }
                                    onFinishTask={async (swBackToDashboard?: boolean | undefined) => {
                                        setShowHistoricTask(false);
                                    }}
                                    showNewTaskButton={false}
                                    othersButtonsWhenProcessing={
                                        <>
                                            <Button mode="action" size="small" onClick={() => JobManagerFrontEnd.cancelJob('job-update-history')}>
                                                Cancel
                                            </Button>
                                            <Button
                                                mode="action"
                                                size="large"
                                                width={200}
                                                onClick={() => {
                                                    updateHistoryTask(true);
                                                }}
                                            >
                                                Force Re-Start
                                            </Button>
                                        </>
                                    }
                                />
                                <br />
                                <br />
                            </>
                        ) : null}

                        {appStore.siteSettings?.debug === true && (
                            <>
                                <table className={styles.tableForm}>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div className={styles.debug}>
                                                    <h2 className={styles.title}>DEBUG MODULE</h2>
                                                    <div className={styles.info}>
                                                        <div className={styles.title}>Servert Time: </div>
                                                        <div className={styles.desc}>{convertMillisToTime(tokensStore.serverTime ?? 0)}</div>
                                                    </div>

                                                    <div className={styles.info}>
                                                        <br />
                                                        initial browser: {convertMillisToTime(initial1)}
                                                        <br />
                                                        initial server: {convertMillisToTime(initial2)}
                                                        <br />
                                                        <br />
                                                        now browser: {convertMillisToTime(new Date().getTime())}
                                                        <br />
                                                        now server: {convertMillisToTime(tokensStore.serverTime!)}
                                                        <br />
                                                        <br />
                                                        diff now browser with initial: {convertMillisToTime(new Date().getTime() - initial1)}
                                                        <br />
                                                        diff now server with initial: {convertMillisToTime(tokensStore.serverTime! - initial2)}
                                                        <br />
                                                        <br />
                                                        diff initials: {convertMillisToTime(initial1 - initial2)}
                                                        <br />
                                                        <br />
                                                        diff now: {convertMillisToTime(new Date().getTime() - tokensStore.serverTime!)}
                                                        <br />
                                                        <br />
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <br />
                                <br />
                            </>
                        )}
                    </>
                </>
            ) : (
                loader
            )}
        </>
    );
}
